/**
 * Returns true if `required` is satisfied by any code in `granted`,
 * using hierarchical prefix matching — identical to the backend HasAnyPermission logic.
 *
 * Examples:
 *   granted = {'REVIEWER.PANEL'}    → satisfies 'REVIEWER.PANEL.VIEW'  ✓
 *   granted = {'REVIEWER'}          → satisfies 'REVIEWER.PANEL.VIEW'  ✓
 *   granted = {'REVIEWER.PROFILE'}  → does NOT satisfy 'REVIEWER.PANEL.VIEW'  ✗
 */
export const matchesWithPrefix = (required: string, granted: Set<string>): boolean => {
  if (granted.has(required)) return true;
  const parts = required.split('.');
  for (let i = parts.length - 1; i >= 1; i--) {
    if (granted.has(parts.slice(0, i).join('.'))) return true;
  }
  return false;
};
